<template>
  <!--回顶-->
  <van-back-top v-if="isShowBackTop" :offset="backTopOption.offset" :bottom="backTopOption.bottom" class="back-top" :class="{ 'page-scroll': isPageScroll }">
    <GlobalImage class="back-top--icon" :src="getImageUrl('public', 'back-top.png')" />
  </van-back-top>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { getImageUrl } from '@/utils'
import { store } from "@/pinia/store"

const storeData = store()
const currentPosition = ref(0)
const scrollTimer = ref()
const pageRatio = (document.body.clientWidth / 375) || 1
const backTopOption = reactive({
  offset: document.body.clientHeight * 0.9,
  bottom: pageRatio * 70
})
const isShowBackTop = computed(() => {
  return storeData.isShowBackTop
})
const isPageScroll = ref(false)

onMounted( () => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

// 页面滚动
const handleScroll = () => {
  currentPosition.value = Math.ceil(window.scrollY || document.documentElement?.scrollTop || document.body?.scrollTop || 0)
  isPageScroll.value = true
  clearTimeout(scrollTimer.value)
  scrollTimer.value = setTimeout(() => {
    isPageScroll.value = false
  }, 1000); // 检测滚动停止的时间间隔
}
</script>

<style lang="scss">
.back-top {
  width: 53px;
  height: 53px;
  background: none;
  box-shadow: none;
  right: 10px;
  animation: all 1s infinite;
  &--icon {
    width: 53px;
    height: 53px;
  }
  &.page-scroll {
    right: -26px;
    .back-top--icon {
      opacity: 0.5;
    }
  }
}
</style>